import {useLocalStorage} from 'platform/components';

import {isNotNil} from 'ramda-adjunct';

import {browserStorageKey} from '@dms/config';

const isDev = process.env.ENV_TYPE === 'dev';

export function useShouldDisableMandatoryFields(): boolean {
  const [mandatoryFieldsValidationOverride] = useLocalStorage<boolean | null>(
    browserStorageKey.DISABLE_MANDATORY_FIELDS_VALIDATION,
    null
  );

  if (!isDev) {
    return false;
  }

  return isNotNil(mandatoryFieldsValidationOverride);
}
